// extracted by mini-css-extract-plugin
export var buttonbox = "index-module--buttonbox--exStW";
export var container = "index-module--container--kPnpc";
export var desc = "index-module--desc--k55Ji";
export var grad = "index-module--grad--zDgBs";
export var section = "index-module--section--GdF8+";
export var subtitle = "index-module--subtitle--SOxv3";
export var title = "index-module--title--YKs6b";